import { regexLibrary } from "./regex-library";

export const validateEmail = (email: string) => {
    if (email) {
        if (!regexLibrary.emailAddress.test(email)) {
            return "Enter a valid email address.";
        } else {
            return "";
        }
    } else {
        return "";
    }
};
